var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'switch' + (_vm.value.includes(_vm.name) ? ' active' : ''),on:{"click":_vm.click}},[_c('div',{staticClass:"switch__switch"})])}
var staticRenderFns = []

export { render, staticRenderFns }